import Vue from 'vue'
import utils from "./utils";
import request from "./request";

Vue.prototype.$utils = utils;
Vue.prototype.$request = request;